import moment from 'moment'
import editImg from '../../../images/Provident-Fund/Edit_Fill.svg'
import detailImg from '../../../images/Detail.svg'
import { useEffect, useState } from 'react'
import {
  createSearchParams,
  useNavigate,
  useSearchParams
} from 'react-router-dom'
import {
  EMP_EJIP,
  EMP_EJIP_ALLMEMBER,
  EMP_EJIP_MEMBERBY_ROUND
} from '../../../router/routes'
import {
  Button,
  ButtonToolbar,
  Col,
  Image,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../nav-title'
import BtnBack from '../../btn-back'
import { BsPlusLg } from 'react-icons/bs'

import ModalCreateRound from './detail/modal-create-round'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { getEjipRoundsAPI } from '../../../services/ejip'

import SpinnerLoading from '../../spinner-loading'
import ModalEditRound from './detail/modal-edit-round'
import CardCustom from '../../custom/card-custom'

export default function EjipDetailPage() {
  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams()

  const name = searchParams.get('name')
  const fundId = searchParams.get('id')

  const [isModalOpenAddMember, setIsModalOpenAddMember] = useState(false)
  const [isModalOpenEditMember, setIsModalOpenEditMember] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [dataById, setDataById] = useState()
  const [data, setData] = useState([])
  const [totalRows, setTotalRows] = useState(0)

  useEffect(() => {
    const body = {
      fundId,
      page: 1,
      size: 20
    }
    fnGetData(body)
  }, [])

  const fnGetData = async (body) => {
    try {
      setIsLoading(true)
      const resp = await getEjipRoundsAPI(body)
      setIsLoading(false)
      if (!resp) return
      if (resp.status) {
        setData(resp.result ?? [])
        setTotalRows(resp.totalRows)
      } else {
        setData([])
        setTotalRows(0)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  const showModalEditMember = (d) => {
    setDataById(d)
    setIsModalOpenEditMember(true)
  }

  const handleCancelEditMember = () => {
    setIsModalOpenEditMember(false)
  }

  const showModalAddMember = () => {
    setIsModalOpenAddMember(true)
  }

  const handleCancelAddMember = () => {
    setIsModalOpenAddMember(false)
  }

  const handleClick = () => {
    navigate(
      {
        pathname: EMP_EJIP_ALLMEMBER,
        search: `?${createSearchParams({
          id: fundId
        })}`
      },
      { replace: false }
    )
  }
  const handleClickRound = (d) => {
    navigate(
      {
        pathname: EMP_EJIP_MEMBERBY_ROUND,
        search: `?${createSearchParams({
          roundId: d.round_id,
          round: d.round,
          fundId
        })}`
      },
      { replace: false }
    )
  }

  return (
    <Row>
      <NavTitle>
        <BtnBack text={name} to={EMP_EJIP} className={' text-muted'} />
      </NavTitle>

      <Col xl={12}>
        <CardCustom className="h-full overflow-auto">
          <div className="p-3 d-flex justify-content-between">
            <label
              className=" my-auto fw-bold"
              style={{
                fontSize: '14px'
              }}
            >
              Total: {totalRows?.toLocaleString()}
            </label>
            <div className="d-flex">
              <Button
                size="sm"
                style={{
                  width: '150px'
                }}
                variant="outline-primary"
                onClick={() => handleClick()}
              >
                View All Member
              </Button>
              <Button
                size="sm"
                className="ms-3 px-4"
                onClick={showModalAddMember}
              >
                <BsPlusLg /> Add Periods
              </Button>
            </div>
          </div>
          <Table>
            <thead
              className="bg-hrms text-white "
              style={{ position: 'sticky', top: '0px' }}
            >
              <tr className=" pointer-event">
                <th className="fw-normal small text-center">#</th>
                <th className="fw-normal small ">Round</th>
                <th className="fw-normal small ">Opening Date</th>
                <th className="fw-normal small ">Closing Date</th>
                <th className="fw-normal small text-center">New Member</th>
                <th className="fw-normal small text-center">Edit</th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((d, i) => {
                  return (
                    <tr className="fw-light font-small-2" key={i}>
                      <td className="text-center fw-normal">{i + 1}</td>
                      <td className="fw-normal">{d.round}</td>
                      <td className=" fw-light">
                        {moment(d.open_date).format('DD/MM/YYYY')}
                      </td>
                      <td className="fw-light">
                        {moment(d.close_date).format('DD/MM/YYYY')}
                      </td>
                      <td className="text-center fw-light">{d.num_member}</td>
                      <td className="text-center fw-light">
                        <span className="d-flex justify-content-center">
                          <ButtonToolbar className="d-flex justify-content-center">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-detail">Detail</Tooltip>
                              }
                            >
                              <Button
                                variant="btn btn-outline-primary"
                                className="border-0 d-flex justify-content-center"
                                size="sm"
                                style={{
                                  width: '32px',
                                  height: '32px'
                                }}
                                onClick={() => handleClickRound(d)}
                              >
                                <Image
                                  src={detailImg}
                                  style={{
                                    width: '20px'
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          </ButtonToolbar>

                          <ButtonToolbar className="d-flex justify-content-center">
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-detail">Edit</Tooltip>
                              }
                            >
                              <Button
                                variant="btn btn-outline-primary"
                                className="border-0 d-flex justify-content-center"
                                size="sm"
                                style={{
                                  width: '32px',
                                  height: '32px'
                                }}
                                onClick={() => showModalEditMember(d)}
                              >
                                <Image
                                  src={editImg}
                                  style={{
                                    width: '20px'
                                  }}
                                />
                              </Button>
                            </OverlayTrigger>
                          </ButtonToolbar>
                        </span>
                      </td>
                    </tr>
                  )
                })
              ) : isLoading ? (
                <tr className="mb-0">
                  <td className="text-center" colSpan={6}>
                    <SpinnerLoading />
                  </td>
                </tr>
              ) : (
                <tr className="mb-0">
                  <td className="text-center" colSpan={6}>
                    -ไม่มีข้อมูล-
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </CardCustom>
      </Col>

      <ModalCreateRound
        fundId={fundId}
        fnData={fnGetData}
        isModalOpen={isModalOpenAddMember}
        handleCancel={handleCancelAddMember}
        setIsModalOpenAddMember={setIsModalOpenAddMember}
      />
      <ModalEditRound
        dataById={dataById}
        fundId={fundId}
        fnData={fnGetData}
        isModalOpen={isModalOpenEditMember}
        handleCancel={handleCancelEditMember}
      />
    </Row>
  )
}
